{
  "HELP_CENTER": {
    "TITLE": "Help Center",
    "NEW_PAGE": {
      "DESCRIPTION": "Create self-service help center portals for your customers. Help them find answers quickly, without waiting. Streamline inquiries, boost agent efficiency, and elevate customer support.",
      "CREATE_PORTAL_BUTTON": "Create Portal"
    },
    "HEADER": {
      "FILTER": "กรองด้วย",
      "SORT": "เรียงด้วย",
      "LOCALE": "Locale",
      "SETTINGS_BUTTON": "ตั้งค่า",
      "NEW_BUTTON": "สร้างบทความ",
      "DROPDOWN_OPTIONS": {
        "PUBLISHED": "Published",
        "DRAFT": "โครงร่าง",
        "ARCHIVED": "Archived"
      },
      "TITLES": {
        "ALL_ARTICLES": "บทความทั้งหมด",
        "MINE": "บทความของฉัน",
        "DRAFT": "บทความที่ร่างไว้",
        "ARCHIVED": "Archived Articles"
      },
      "LOCALE_SELECT": {
        "TITLE": "Select locale",
        "PLACEHOLDER": "Select locale",
        "NO_RESULT": "No locale found",
        "SEARCH_PLACEHOLDER": "Search locale"
      }
    },
    "EDIT_HEADER": {
      "ALL_ARTICLES": "บทความทั้งหมด",
      "PUBLISH_BUTTON": "Publish",
      "MOVE_TO_ARCHIVE_BUTTON": "Move to archived",
      "PREVIEW": "Preview",
      "ADD_TRANSLATION": "เพิ่มการแปลภาษา",
      "OPEN_SIDEBAR": "Open sidebar",
      "CLOSE_SIDEBAR": "Close sidebar",
      "SAVING": "กำลังบันทึก...",
      "SAVED": "บันทึกแล้ว"
    },
    "ARTICLE_EDITOR": {
      "IMAGE_UPLOAD": {
        "TITLE": "อัปโหลดรูปภาพ",
        "UPLOADING": "กำลังอัพโหลด",
        "SUCCESS": "Image uploaded successfully",
        "ERROR": "Error while uploading image",
        "UN_AUTHORIZED_ERROR": "You are not authorized to upload images",
        "ERROR_FILE_SIZE": "Image size should be less than {size}MB",
        "ERROR_FILE_FORMAT": "Image format should be jpg, jpeg or png",
        "ERROR_FILE_DIMENSIONS": "Image dimensions should be less than 2000 x 2000"
      }
    },
    "ARTICLE_SETTINGS": {
      "TITLE": "ตั้งค่าบทความ",
      "FORM": {
        "CATEGORY": {
          "LABEL": "หมวดหมู่",
          "TITLE": "เลือกหมวดหมู่",
          "PLACEHOLDER": "เลือกหมวดหมู่",
          "NO_RESULT": "ไม่พบหมวดหมู่",
          "SEARCH_PLACEHOLDER": "ค้นหาหมวดหมู่"
        },
        "AUTHOR": {
          "LABEL": "ผู้เขียน",
          "TITLE": "เลือกผู้เขียน",
          "PLACEHOLDER": "เลือกผู้เขียน",
          "NO_RESULT": "ไม่พบผู้เขียน",
          "SEARCH_PLACEHOLDER": "ค้นหาผู้แต่ง"
        },
        "META_TITLE": {
          "LABEL": "Meta title",
          "PLACEHOLDER": "Add a meta title"
        },
        "META_DESCRIPTION": {
          "LABEL": "Meta description",
          "PLACEHOLDER": "Add your meta description for better SEO results..."
        },
        "META_TAGS": {
          "LABEL": "Meta tags",
          "PLACEHOLDER": "Add meta tags separated by comma..."
        }
      },
      "BUTTONS": {
        "ARCHIVE": "Archive article",
        "DELETE": "ลบบทความ"
      }
    },
    "ARTICLE_SEARCH_RESULT": {
      "UNCATEGORIZED": "Uncategorized",
      "SEARCH_RESULTS": "Search results for {query}",
      "EMPTY_TEXT": "Search for articles to insert into replies.",
      "SEARCH_LOADER": "Searching...",
      "INSERT_ARTICLE": "Insert",
      "NO_RESULT": "No articles found",
      "COPY_LINK": "Copy article link to clipboard",
      "OPEN_LINK": "Open article in new tab",
      "PREVIEW_LINK": "Preview article"
    },
    "PORTAL": {
      "HEADER": "ศูนย์รวม",
      "DEFAULT": "Default",
      "NEW_BUTTON": "New Portal",
      "ACTIVE_BADGE": "ใช้งานอยู่",
      "CHOOSE_LOCALE_LABEL": "Choose a locale",
      "LOADING_MESSAGE": "Loading portals...",
      "ARTICLES_LABEL": "บทความ",
      "NO_PORTALS_MESSAGE": "There are no available portals",
      "ADD_NEW_LOCALE": "Add a new locale",
      "POPOVER": {
        "TITLE": "Portals",
        "PORTAL_SETTINGS": "Portal settings",
        "SUBTITLE": "You have multiple portals and can have different locales for each portal.",
        "CANCEL_BUTTON_LABEL": "ยกเลิก",
        "CHOOSE_LOCALE_BUTTON": "Choose Locale"
      },
      "PORTAL_SETTINGS": {
        "LIST_ITEM": {
          "HEADER": {
            "COUNT_LABEL": "บทความ",
            "ADD": "Add locale",
            "VISIT": "Visit site",
            "SETTINGS": "ตั้งค่า",
            "DELETE": "ลบ"
          },
          "PORTAL_CONFIG": {
            "TITLE": "Portal Configurations",
            "ITEMS": {
              "NAME": "ชื่อ",
              "DOMAIN": "Custom domain",
              "SLUG": "Slug",
              "TITLE": "Portal title",
              "THEME": "Theme color",
              "SUB_TEXT": "Portal sub text"
            }
          },
          "AVAILABLE_LOCALES": {
            "TITLE": "Available locales",
            "TABLE": {
              "NAME": "Locale name",
              "CODE": "Locale code",
              "ARTICLE_COUNT": "No. of articles",
              "CATEGORIES": "No. of categories",
              "SWAP": "Swap",
              "DELETE": "ลบ",
              "DEFAULT_LOCALE": "Default"
            }
          }
        },
        "DELETE_PORTAL": {
          "TITLE": "Delete portal",
          "MESSAGE": "Are you sure you want to delete this portal",
          "YES": "Yes, delete portal",
          "NO": "No, keep portal",
          "API": {
            "DELETE_SUCCESS": "Portal deleted successfully",
            "DELETE_ERROR": "Error while deleting portal"
          }
        },
        "SEND_CNAME_INSTRUCTIONS": {
          "API": {
            "SUCCESS_MESSAGE": "CNAME instructions sent successfully",
            "ERROR_MESSAGE": "Error while sending CNAME instructions"
          }
        }
      },
      "EDIT": {
        "HEADER_TEXT": "Edit portal",
        "TABS": {
          "BASIC_SETTINGS": {
            "TITLE": "Basic information"
          },
          "CUSTOMIZATION_SETTINGS": {
            "TITLE": "Portal customization"
          },
          "CATEGORY_SETTINGS": {
            "TITLE": "Categories"
          },
          "LOCALE_SETTINGS": {
            "TITLE": "Locales"
          }
        },
        "CATEGORIES": {
          "TITLE": "Categories in",
          "NEW_CATEGORY": "New category",
          "TABLE": {
            "NAME": "ชื่อ",
            "DESCRIPTION": "คำอธิบาย",
            "LOCALE": "Locale",
            "ARTICLE_COUNT": "No. of articles",
            "ACTION_BUTTON": {
              "EDIT": "Edit category",
              "DELETE": "Delete category"
            },
            "EMPTY_TEXT": "No categories found"
          }
        },
        "EDIT_BASIC_INFO": {
          "BUTTON_TEXT": "Update basic settings"
        }
      },
      "ADD": {
        "CREATE_FLOW": {
          "BASIC": {
            "TITLE": "Help center information",
            "BODY": "Basic information about portal"
          },
          "CUSTOMIZATION": {
            "TITLE": "Help center customization",
            "BODY": "Customize portal"
          },
          "FINISH": {
            "TITLE": "Voila! 🎉",
            "BODY": "You're all set!"
          }
        },
        "CREATE_FLOW_PAGE": {
          "BACK_BUTTON": "ย้อนกลับ",
          "BASIC_SETTINGS_PAGE": {
            "HEADER": "Create Portal",
            "TITLE": "Help center information",
            "CREATE_BASIC_SETTING_BUTTON": "Create portal basic settings"
          },
          "CUSTOMIZATION_PAGE": {
            "HEADER": "Portal customisation",
            "TITLE": "Help center customization",
            "UPDATE_PORTAL_BUTTON": "Update portal settings"
          },
          "FINISH_PAGE": {
            "TITLE": "Voila!🎉 You're all set up!",
            "MESSAGE": "You can now see this created portal on your all portals page.",
            "FINISH": "Go to all portals page"
          }
        },
        "LOGO": {
          "LABEL": "Logo",
          "UPLOAD_BUTTON": "Upload logo",
          "HELP_TEXT": "This logo will be displayed on the portal header.",
          "IMAGE_UPLOAD_SUCCESS": "Logo uploaded successfully",
          "IMAGE_UPLOAD_ERROR": "Logo deleted successfully",
          "IMAGE_DELETE_ERROR": "Error while deleting logo"
        },
        "NAME": {
          "LABEL": "ชื่อ",
          "PLACEHOLDER": "Portal name",
          "HELP_TEXT": "The name will be used in the public facing portal internally.",
          "ERROR": "โปรดระบุชื่อ"
        },
        "SLUG": {
          "LABEL": "Slug",
          "PLACEHOLDER": "Portal slug for urls",
          "ERROR": "Slug is required"
        },
        "DOMAIN": {
          "LABEL": "Custom Domain",
          "PLACEHOLDER": "Portal custom domain",
          "HELP_TEXT": "Add only If you want to use a custom domain for your portals. Eg: {exampleURL}",
          "ERROR": "Enter a valid domain URL"
        },
        "HOME_PAGE_LINK": {
          "LABEL": "Home Page Link",
          "PLACEHOLDER": "Portal home page link",
          "HELP_TEXT": "The link used to return from the portal to the home page. Eg: {exampleURL}",
          "ERROR": "Enter a valid home page URL"
        },
        "THEME_COLOR": {
          "LABEL": "Portal theme color",
          "HELP_TEXT": "This color will show as the theme color for the portal."
        },
        "PAGE_TITLE": {
          "LABEL": "Page Title",
          "PLACEHOLDER": "Portal page title",
          "HELP_TEXT": "The page title will be used in the public facing portal.",
          "ERROR": "Page title is required"
        },
        "HEADER_TEXT": {
          "LABEL": "Header Text",
          "PLACEHOLDER": "Portal header text",
          "HELP_TEXT": "The Portal header text will be used in the public facing portal.",
          "ERROR": "Portal header text is required"
        },
        "API": {
          "SUCCESS_MESSAGE_FOR_BASIC": "Portal created successfully.",
          "ERROR_MESSAGE_FOR_BASIC": "Couldn't create the portal. Try again.",
          "SUCCESS_MESSAGE_FOR_UPDATE": "Portal updated successfully.",
          "ERROR_MESSAGE_FOR_UPDATE": "Couldn't update the portal. Try again."
        }
      },
      "ADD_LOCALE": {
        "TITLE": "Add a new locale",
        "SUB_TITLE": "This adds a new locale to your available translation list.",
        "PORTAL": "Portal",
        "LOCALE": {
          "LABEL": "Locale",
          "PLACEHOLDER": "Choose a locale",
          "ERROR": "Locale is required"
        },
        "BUTTONS": {
          "CREATE": "Create locale",
          "CANCEL": "ยกเลิก"
        },
        "API": {
          "SUCCESS_MESSAGE": "Locale added successfully",
          "ERROR_MESSAGE": "Unable to add locale. Try again."
        }
      },
      "CHANGE_DEFAULT_LOCALE": {
        "API": {
          "SUCCESS_MESSAGE": "Default locale updated successfully",
          "ERROR_MESSAGE": "Unable to update default locale. Try again."
        }
      },
      "DELETE_LOCALE": {
        "API": {
          "SUCCESS_MESSAGE": "Locale removed from portal successfully",
          "ERROR_MESSAGE": "Unable to remove locale from portal. Try again."
        }
      },
      "DRAFT_LOCALE": {
        "API": {
          "SUCCESS_MESSAGE": "Locale moved to draft successfully",
          "ERROR_MESSAGE": "Unable to move locale to draft. Try again."
        }
      },
      "PUBLISH_LOCALE": {
        "API": {
          "SUCCESS_MESSAGE": "Locale published successfully",
          "ERROR_MESSAGE": "Unable to publish locale. Try again."
        }
      }
    },
    "TABLE": {
      "LOADING_MESSAGE": "Loading articles...",
      "404": "No articles matches your search 🔍",
      "NO_ARTICLES": "There are no available articles",
      "HEADERS": {
        "TITLE": "หัวข้อ",
        "CATEGORY": "Category",
        "READ_COUNT": "Views",
        "STATUS": "สถานะ",
        "LAST_EDITED": "Last edited"
      },
      "COLUMNS": {
        "BY": "by",
        "AUTHOR_NOT_AVAILABLE": "Author is not available"
      }
    },
    "EDIT_ARTICLE": {
      "LOADING": "Loading article...",
      "TITLE_PLACEHOLDER": "Article title goes here",
      "CONTENT_PLACEHOLDER": "Write your article here",
      "API": {
        "ERROR": "Error while saving article"
      }
    },
    "PUBLISH_ARTICLE": {
      "API": {
        "ERROR": "Error while publishing article",
        "SUCCESS": "Article published successfully"
      }
    },
    "ARCHIVE_ARTICLE": {
      "API": {
        "ERROR": "Error while archiving article",
        "SUCCESS": "Article archived successfully"
      }
    },
    "DRAFT_ARTICLE": {
      "API": {
        "ERROR": "Error while drafting article",
        "SUCCESS": "Article drafted successfully"
      }
    },
    "DELETE_ARTICLE": {
      "MODAL": {
        "CONFIRM": {
          "TITLE": "ยืนยันการลบ",
          "MESSAGE": "Are you sure to delete the article?",
          "YES": "เอาเลย",
          "NO": "ไม่"
        }
      },
      "API": {
        "SUCCESS_MESSAGE": "Article deleted successfully",
        "ERROR_MESSAGE": "Error while deleting article"
      }
    },
    "REORDER_ARTICLE": {
      "API": {
        "ERROR_MESSAGE": "Unable to reorder articles. Please try again."
      }
    },
    "REORDER_CATEGORY": {
      "API": {
        "ERROR_MESSAGE": "Unable to reorder categories. Please try again."
      }
    },
    "CREATE_ARTICLE": {
      "ERROR_MESSAGE": "Please add the article heading and content then only you can update the settings"
    },
    "SIDEBAR": {
      "SEARCH": {
        "PLACEHOLDER": "Search for articles"
      }
    },
    "CATEGORY": {
      "ADD": {
        "TITLE": "Create a category",
        "SUB_TITLE": "The category will be used in the public facing portal to categorize articles.",
        "PORTAL": "Portal",
        "LOCALE": "Locale",
        "NAME": {
          "LABEL": "ชื่อ",
          "PLACEHOLDER": "Category name",
          "HELP_TEXT": "The category name and icon will be used in the public facing portal to categorize articles.",
          "ERROR": "โปรดระบุชื่อ"
        },
        "SLUG": {
          "LABEL": "Slug",
          "PLACEHOLDER": "Category slug for urls",
          "HELP_TEXT": "app.chatwoot.com/hc/my-portal/en-US/categories/my-slug",
          "ERROR": "Slug is required"
        },
        "DESCRIPTION": {
          "LABEL": "คำอธิบาย",
          "PLACEHOLDER": "Give a short description about the category.",
          "ERROR": "โปรดระบุคำอธิบาย"
        },
        "BUTTONS": {
          "CREATE": "Create category",
          "CANCEL": "ยกเลิก"
        },
        "API": {
          "SUCCESS_MESSAGE": "Category created successfully",
          "ERROR_MESSAGE": "Unable to create category"
        }
      },
      "EDIT": {
        "TITLE": "Edit a category",
        "SUB_TITLE": "Editing a category will update the category in the public facing portal.",
        "PORTAL": "Portal",
        "LOCALE": "Locale",
        "NAME": {
          "LABEL": "ชื่อ",
          "PLACEHOLDER": "Category name",
          "HELP_TEXT": "The category name and icon will be used in the public facing portal to categorize articles.",
          "ERROR": "โปรดระบุชื่อ"
        },
        "SLUG": {
          "LABEL": "Slug",
          "PLACEHOLDER": "Category slug for urls",
          "HELP_TEXT": "app.chatwoot.com/hc/my-portal/en-US/categories/my-slug",
          "ERROR": "Slug is required"
        },
        "DESCRIPTION": {
          "LABEL": "คำอธิบาย",
          "PLACEHOLDER": "Give a short description about the category.",
          "ERROR": "โปรดระบุคำอธิบาย"
        },
        "BUTTONS": {
          "CREATE": "Update category",
          "CANCEL": "ยกเลิก"
        },
        "API": {
          "SUCCESS_MESSAGE": "Category updated successfully",
          "ERROR_MESSAGE": "Unable to update category"
        }
      },
      "DELETE": {
        "API": {
          "SUCCESS_MESSAGE": "Category deleted successfully",
          "ERROR_MESSAGE": "Unable to delete category"
        }
      }
    },
    "ARTICLE_SEARCH": {
      "TITLE": "Search articles",
      "PLACEHOLDER": "Search articles",
      "NO_RESULT": "No articles found",
      "SEARCHING": "Searching...",
      "SEARCH_BUTTON": "ค้นหา",
      "INSERT_ARTICLE": "Insert link",
      "IFRAME_ERROR": "URL is empty or invalid. Unable to display content.",
      "OPEN_ARTICLE_SEARCH": "Insert article from Help Center",
      "SUCCESS_ARTICLE_INSERTED": "Article inserted successfully",
      "PREVIEW_LINK": "Preview article",
      "CANCEL": "ปิด",
      "BACK": "ย้อนกลับ",
      "BACK_RESULTS": "Back to results"
    },
    "UPGRADE_PAGE": {
      "TITLE": "Help Center",
      "DESCRIPTION": "Create user-friendly self-service portals. Help your users to access the articles and get support 24/7. Upgrade your subscription to enable this feature.",
      "SELF_HOSTED_DESCRIPTION": "Create user-friendly self-service portals. Help your users to access the articles and get support 24/7. Please contact your administrator to enable this feature.",
      "BUTTON": {
        "LEARN_MORE": "เรียนรู้เพิ่มเติม",
        "UPGRADE": "Upgrade"
      },
      "FEATURES": {
        "PORTALS": {
          "TITLE": "Multiple portals",
          "DESCRIPTION": "Create multiple help center portals for different products using the same account."
        },
        "LOCALES": {
          "TITLE": "Full support for locales",
          "DESCRIPTION": "Localize the portal in your language. We support all locales and allow translations for every article."
        },
        "SEO": {
          "TITLE": "SEO-friendly design",
          "DESCRIPTION": "Customize your meta tags to improve your visibility on search engines with our SEO-friendly pages."
        },
        "API": {
          "TITLE": "Full API support",
          "DESCRIPTION": "Use the portal as a headless CMS with third party front-end frameworks using our APIs."
        }
      }
    },
    "LOADING": "Loading...",
    "ARTICLES_PAGE": {
      "ARTICLE_CARD": {
        "CARD": {
          "VIEWS": "{count} view | {count} views",
          "DROPDOWN_MENU": {
            "PUBLISH": "Publish",
            "DRAFT": "โครงร่าง",
            "ARCHIVE": "Archive",
            "TRANSLATE": "Translate",
            "DELETE": "ลบ"
          },
          "STATUS": {
            "DRAFT": "โครงร่าง",
            "PUBLISHED": "Published",
            "ARCHIVED": "Archived"
          },
          "PENDING_EDITS": "Unpublished edits",
          "PENDING_EDITS_TOOLTIP": "This published article has unpublished edits",
          "CATEGORY": {
            "UNCATEGORISED": "Uncategorised"
          }
        }
      },
      "ARTICLES_HEADER": {
        "TABS": {
          "ALL": "All articles",
          "MINE": "ของฉัน",
          "DRAFT": "โครงร่าง",
          "PUBLISHED": "Published",
          "ARCHIVED": "Archived"
        },
        "CATEGORY": {
          "ALL": "All categories"
        },
        "LOCALE": {
          "ALL": "All locales"
        },
        "SEARCH_PLACEHOLDER": "Search articles...",
        "NEW_ARTICLE": "New article"
      },
      "EMPTY_STATE": {
        "ALL": {
          "TITLE": "Write an article",
          "SUBTITLE": "Write a rich article, let’s get started!",
          "BUTTON_LABEL": "New article"
        },
        "MINE": {
          "TITLE": "You haven't written any articles here",
          "SUBTITLE": "All articles written by you show up here for quick access."
        },
        "DRAFT": {
          "TITLE": "There are no articles in drafts",
          "SUBTITLE": "Draft articles will appear here"
        },
        "PUBLISHED": {
          "TITLE": "There are no published articles",
          "SUBTITLE": "Published articles will appear here"
        },
        "ARCHIVED": {
          "TITLE": "There are no articles in the archive",
          "SUBTITLE": "Archived articles don't show up on the portal, you can use it to mark deprecated or outdated pages"
        },
        "CATEGORY": {
          "TITLE": "There are no articles in this category",
          "SUBTITLE": "Articles in this category will appear here"
        },
        "SEARCH": {
          "TITLE": "No matching articles",
          "SUBTITLE": "We couldn't find any articles matching your search. Try a different term."
        }
      },
      "BULK_TRANSLATE": {
        "TITLE": "Translate article | Translate {count} articles",
        "DESCRIPTION": "Translate the selected article to another language. | Translate the selected articles to another language.",
        "LOCALE_LABEL": "Target language",
        "LOCALE_PLACEHOLDER": "Select a language",
        "CATEGORY_LABEL": "Target category",
        "CATEGORY_PLACEHOLDER": "Select a category",
        "OPTIONAL": "(optional)",
        "CONFIRM": "Translate",
        "SELECT_ALL": "Select all ({count})",
        "SELECTED_COUNT": "{count} selected",
        "CLEAR_SELECTION": "Clear selection",
        "TRANSLATE_BUTTON": "Translate",
        "CONFIRM_OVERWRITE": "Overwrite and translate",
        "DUPLICATE_WARNING": "A translation already exists for this article in the selected language. | Translations already exist for {count} articles in the selected language.",
        "DUPLICATE_CONFIRM_HINT": "Click translate again to overwrite the existing translation.",
        "API": {
          "SUCCESS_MESSAGE": "Translation in progress. The article will appear as a draft once ready.",
          "ERROR_MESSAGE": "Failed to start translation. Please try again."
        }
      },
      "BULK_ACTIONS": {
        "PUBLISH": "Publish",
        "DRAFT": "โครงร่าง",
        "ARCHIVE": "Archive",
        "TRANSLATE": "Translate",
        "MOVE_TO_CATEGORY": "Category",
        "DELETE": "ลบ",
        "STATUS_SUCCESS": "Articles updated successfully",
        "STATUS_ERROR": "Failed to update articles",
        "STATUS_SKIPPED": "1 article with unpublished edits was skipped — open it to publish or discard. | {count} articles with unpublished edits were skipped — open them to publish or discard.",
        "STATUS_SKIPPED_ALL": "These articles have unpublished edits — open each to publish or discard.",
        "CATEGORY_SUCCESS": "Articles moved successfully",
        "CATEGORY_ERROR": "Failed to move articles",
        "DELETE_CONFIRM_TITLE": "Delete article | Delete {count} articles",
        "DELETE_CONFIRM_DESCRIPTION": "This will permanently delete the selected article. This action cannot be undone. | This will permanently delete {count} selected articles. This action cannot be undone.",
        "DELETE_CONFIRM": "ลบ",
        "DELETE_SUCCESS": "Articles deleted successfully",
        "DELETE_ERROR": "Failed to delete articles"
      }
    },
    "CATEGORY_PAGE": {
      "CATEGORY_HEADER": {
        "NEW_CATEGORY": "New category",
        "EDIT_CATEGORY": "Edit category",
        "SEARCH_PLACEHOLDER": "Search categories...",
        "CATEGORIES_COUNT": "{n} category | {n} categories",
        "BREADCRUMB": {
          "CATEGORY_LOCALE": "Categories ({localeCode})",
          "ACTIVE_CATEGORY": "{categoryName} ({categoryCount} articles) | {categoryName} ({categoryCount} article)"
        }
      },
      "CATEGORY_EMPTY_STATE": {
        "TITLE": "No categories found",
        "SUBTITLE": "Categories will appear here. You can add a category by clicking the 'New Category' button."
      },
      "SEARCH_EMPTY_STATE": {
        "TITLE": "No matching categories",
        "SUBTITLE": "We couldn't find any categories matching your search. Try a different term."
      },
      "CATEGORY_CARD": {
        "ARTICLES_COUNT": "{count} article | {count} articles"
      },
      "CATEGORY_DIALOG": {
        "CREATE": {
          "API": {
            "SUCCESS_MESSAGE": "Category created successfully",
            "ERROR_MESSAGE": "Unable to create category"
          }
        },
        "EDIT": {
          "API": {
            "SUCCESS_MESSAGE": "Category updated successfully",
            "ERROR_MESSAGE": "Unable to update category"
          }
        },
        "DELETE": {
          "API": {
            "SUCCESS_MESSAGE": "Category deleted successfully",
            "ERROR_MESSAGE": "Unable to delete category"
          }
        },
        "HEADER": {
          "CREATE": "Create category",
          "EDIT": "Edit category",
          "DESCRIPTION": "Editing a category will update the category in the public facing portal.",
          "PORTAL": "Portal",
          "LOCALE": "Locale"
        },
        "FORM": {
          "NAME": {
            "LABEL": "ชื่อ",
            "PLACEHOLDER": "Category name",
            "ERROR": "โปรดระบุชื่อ"
          },
          "SLUG": {
            "LABEL": "Slug",
            "PLACEHOLDER": "Category slug for urls",
            "ERROR": "Slug is required",
            "HELP_TEXT": "app.chatwoot.com/hc/{portalSlug}/{localeCode}/categories/{categorySlug}"
          },
          "DESCRIPTION": {
            "LABEL": "คำอธิบาย",
            "PLACEHOLDER": "Give a short description about the category.",
            "ERROR": "โปรดระบุคำอธิบาย"
          }
        },
        "BUTTONS": {
          "CREATE": "สร้าง",
          "EDIT": "อัพเดท",
          "CANCEL": "ยกเลิก"
        }
      }
    },
    "LOCALES_PAGE": {
      "LOCALES_COUNT": "No locales available | {n} locale | {n} locales",
      "NEW_LOCALE_BUTTON_TEXT": "New locale",
      "SEARCH_PLACEHOLDER": "Search locales...",
      "SEARCH_EMPTY_STATE": {
        "TITLE": "No matching locales",
        "SUBTITLE": "We couldn't find any locales matching your search. Try a different term."
      },
      "LOCALE_CARD": {
        "ARTICLES_COUNT": "{count} article | {count} articles",
        "CATEGORIES_COUNT": "{count} category | {count} categories",
        "DEFAULT": "Default",
        "DRAFT": "โครงร่าง",
        "DROPDOWN_MENU": {
          "MAKE_DEFAULT": "Make default",
          "MOVE_TO_DRAFT": "Move to draft",
          "PUBLISH_LOCALE": "Publish locale",
          "CUSTOMIZE_CONTENT": "Localize content",
          "SELECT_POPULAR_CONTENT": "Select recommended content",
          "DELETE": "ลบ"
        }
      },
      "POPULAR_CONTENT_DIALOG": {
        "TITLE": "Recommended content",
        "DESCRIPTION": "Pick up to 3 categories and 6 articles to feature on this locale's help center home page. Drag them into the order you want visitors to see.",
        "SEARCH": "Search...",
        "EMPTY": "No matching results",
        "ADD_ANOTHER": "Add another...",
        "SLOTS_LEFT": "{count} slots left",
        "OVERRIDING_DEFAULTS": "Overriding defaults for this locale",
        "CONFIRM": "Save recommendations",
        "CATEGORIES": {
          "LABEL": "Recommended categories",
          "ARTICLES_COUNT": "No articles | {count} article | {count} articles"
        },
        "ARTICLES": {
          "LABEL": "Recommended articles",
          "IN_CATEGORY": "in {category}",
          "UNCATEGORIZED": "Uncategorized"
        },
        "API": {
          "SUCCESS_MESSAGE": "Recommended content updated successfully",
          "ERROR_MESSAGE": "Unable to update recommended content. Try again."
        }
      },
      "CONTENT_DIALOG": {
        "TITLE": "Localize content",
        "DESCRIPTION": "Set values specific to this locale. Anything left blank falls back to the default locale.",
        "NAME": {
          "LABEL": "ชื่อ"
        },
        "PAGE_TITLE": {
          "LABEL": "Page title"
        },
        "HEADER_TEXT": {
          "LABEL": "Header text"
        },
        "API": {
          "SUCCESS_MESSAGE": "Locale content updated successfully",
          "ERROR_MESSAGE": "Unable to update locale content. Try again."
        }
      },
      "ADD_LOCALE_DIALOG": {
        "TITLE": "Add a new locale",
        "DESCRIPTION": "Select the language in which this article will be written. This will be added to your list of translations, and you can add more later.",
        "COMBOBOX": {
          "PLACEHOLDER": "Select locale..."
        },
        "STATUS": {
          "LABEL": "สถานะ",
          "OPTIONS": {
            "LIVE": "Published",
            "DRAFT": "โครงร่าง"
          }
        },
        "API": {
          "SUCCESS_MESSAGE": "Locale added successfully",
          "ERROR_MESSAGE": "Unable to add locale. Try again."
        }
      }
    },
    "EDIT_ARTICLE_PAGE": {
      "HEADER": {
        "STATUS": {
          "SAVING": "กำลังบันทึก...",
          "SAVED": "บันทึกแล้ว"
        },
        "PREVIEW": "Preview",
        "PUBLISH": "Publish",
        "PUBLISH_CHANGES": "Publish changes",
        "PUBLISH_CHANGES_SUCCESS": "Changes published successfully",
        "PUBLISH_CHANGES_ERROR": "Could not publish changes",
        "SAVE_IN_PROGRESS": "Still saving your latest changes — please try again in a moment.",
        "DISCARD_CHANGES": "Discard changes",
        "DISCARD_CHANGES_SUCCESS": "Changes discarded",
        "DISCARD_CHANGES_ERROR": "Could not discard changes",
        "PENDING_CHANGES": "Pending changes",
        "VIEW_CHANGES": "View unpublished changes",
        "DRAFT": "โครงร่าง",
        "ARCHIVE": "Archive",
        "BACK_TO_ARTICLES": "Back to articles"
      },
      "PENDING_CHANGES_POPOVER": {
        "TITLE": "Unpublished changes",
        "DESCRIPTION": "This article has draft changes that aren't live yet. Apply them before changing the status, or discard them?",
        "APPLY": "Apply changes",
        "DISCARD": "Discard changes"
      },
      "DIFF_DIALOG": {
        "TITLE": "Unpublished changes",
        "DESCRIPTION": "Compare your draft against the version that's currently live.",
        "TITLE_LABEL": "หัวข้อ"
      },
      "EDIT_ARTICLE": {
        "MORE_PROPERTIES": "More properties",
        "UNCATEGORIZED": "Uncategorized",
        "EDITOR_PLACEHOLDER": "Write your content here. Type '/' for formatting options."
      },
      "ARTICLE_PROPERTIES": {
        "ARTICLE_PROPERTIES": "Article properties",
        "META_DESCRIPTION": "Meta description",
        "META_DESCRIPTION_PLACEHOLDER": "Add meta description",
        "META_TITLE": "Meta title",
        "META_TITLE_PLACEHOLDER": "Add meta title",
        "META_TAGS": "Meta tags",
        "META_TAGS_PLACEHOLDER": "Add meta tags"
      },
      "API": {
        "ERROR": "Error while saving article"
      }
    },
    "PORTAL_SWITCHER": {
      "NEW_PORTAL": "New portal",
      "PORTALS": "ศูนย์รวม",
      "CREATE_PORTAL": "Create and manage multiple portals",
      "ARTICLES": "บทความ",
      "DOMAIN": "โดเมน",
      "PORTAL_NAME": "Portal name"
    },
    "CREATE_PORTAL_DIALOG": {
      "TITLE": "Create new portal",
      "DESCRIPTION": "Give your portal a name and create a user-friendly URL slug. You can modify both later in the settings.",
      "CONFIRM_BUTTON_LABEL": "สร้าง",
      "NAME": {
        "LABEL": "ชื่อ",
        "PLACEHOLDER": "User Guide | Chatwoot",
        "MESSAGE": "Choose an name for your portal.",
        "ERROR": "โปรดระบุชื่อ"
      },
      "SLUG": {
        "LABEL": "Slug",
        "PLACEHOLDER": "user-guide",
        "ERROR": "Slug is required",
        "FORMAT_ERROR": "Please enter a valid slug, for eg: user-guide"
      }
    },
    "PORTAL_SETTINGS": {
      "FORM": {
        "AVATAR": {
          "LABEL": "Logo",
          "IMAGE_UPLOAD_ERROR": "Couldn't upload image! Try again",
          "IMAGE_UPLOAD_SUCCESS": "Image added successfully. Please click on save changes to save the logo",
          "IMAGE_DELETE_SUCCESS": "Logo deleted successfully",
          "IMAGE_DELETE_ERROR": "Unable to delete logo",
          "IMAGE_UPLOAD_SIZE_ERROR": "Image size should be less than {size}MB"
        },
        "NAME": {
          "LABEL": "ชื่อ",
          "PLACEHOLDER": "Portal name",
          "ERROR": "โปรดระบุชื่อ"
        },
        "HEADER_TEXT": {
          "LABEL": "Header text",
          "PLACEHOLDER": "Portal header text"
        },
        "PAGE_TITLE": {
          "LABEL": "Page title",
          "PLACEHOLDER": "Portal page title"
        },
        "HOME_PAGE_LINK": {
          "LABEL": "Home page link",
          "PLACEHOLDER": "Portal home page link",
          "ERROR": "Enter a valid URL. The Home page link must start with 'http://' or 'https://'."
        },
        "SLUG": {
          "LABEL": "Slug",
          "PLACEHOLDER": "Portal slug"
        },
        "LIVE_CHAT_WIDGET": {
          "LABEL": "Live chat widget",
          "PLACEHOLDER": "Select live chat widget",
          "HELP_TEXT": "Select a live chat widget that will appear on your help center",
          "NONE_OPTION": "No widget"
        },
        "BRAND_COLOR": {
          "LABEL": "Brand color"
        },
        "SAVE_CHANGES": "Save changes"
      },
      "CONFIGURATION_FORM": {
        "CUSTOM_DOMAIN": {
          "HEADER": "Custom domain",
          "LABEL": "Custom domain:",
          "DESCRIPTION": "You can host your portal on a custom domain. For instance, if your website is yourdomain.com and you want your portal available at docs.yourdomain.com, simply enter that in this field.",
          "STATUS_DESCRIPTION": "Your custom portal will start working as soon as it is verified.",
          "PLACEHOLDER": "Portal custom domain",
          "EDIT_BUTTON": "เเก้ไข",
          "ADD_BUTTON": "Add custom domain",
          "STATUS": {
            "LIVE": "ขณะนี้",
            "PENDING": "Awaiting verification",
            "ERROR": "Verification failed"
          },
          "DIALOG": {
            "ADD_HEADER": "Add custom domain",
            "EDIT_HEADER": "Edit custom domain",
            "ADD_CONFIRM_BUTTON_LABEL": "Add domain",
            "EDIT_CONFIRM_BUTTON_LABEL": "Update domain",
            "LABEL": "Custom domain",
            "PLACEHOLDER": "Portal custom domain",
            "ERROR": "Custom domain is required",
            "FORMAT_ERROR": "Please enter a valid domain URL e.g. docs.yourdomain.com"
          },
          "DNS_CONFIGURATION_DIALOG": {
            "HEADER": "DNS configuration",
            "DESCRIPTION": "Log in to the account you have with your DNS provider, and add a CNAME record for subdomain pointing to chatwoot.help",
            "COPY": "Successfully copied CNAME",
            "SEND_INSTRUCTIONS": {
              "HEADER": "Send instructions",
              "DESCRIPTION": "If you would prefer to have someone from your development team to handle this step, you can enter email address below, and we will send them the required instructions.",
              "PLACEHOLDER": "Enter their email",
              "ERROR": "Enter a valid email address",
              "SEND_BUTTON": "ส่ง"
            }
          }
        },
        "DELETE_PORTAL": {
          "BUTTON": "Delete {portalName}",
          "HEADER": "Delete portal",
          "DESCRIPTION": "Permanently delete this portal. This action is irreversible",
          "DIALOG": {
            "HEADER": "Sure you want to delete {portalName}?",
            "DESCRIPTION": "This is a permanent action that cannot be reversed.",
            "CONFIRM_BUTTON_LABEL": "ลบ"
          }
        },
        "EDIT_CONFIGURATION": "Edit configuration"
      },
      "LAYOUT_CONTENT": {
        "HEADER": "Appearance",
        "DESCRIPTION": "Pick the layout that fits how your visitors read.",
        "LAYOUT": {
          "CLASSIC": {
            "TITLE": "Classic",
            "DESCRIPTION": "A welcoming home page with search and featured topics."
          },
          "SIDEBAR": {
            "TITLE": "Documentation",
            "DESCRIPTION": "Side-by-side navigation that keeps every guide a click away."
          }
        },
        "SOCIAL_LINKS": {
          "HEADER": "Social links",
          "DESCRIPTION": "Add the handle for each network and your help center builds the full link. Shown in the documentation layout footer.",
          "PLACEHOLDER": "handle",
          "ADD": "Add social link",
          "REMOVE": "ลบรูปภาพ"
        },
        "SAVE": "Save changes"
      },
      "API": {
        "CREATE_PORTAL": {
          "SUCCESS_MESSAGE": "Portal created successfully",
          "ERROR_MESSAGE": "Unable to create portal"
        },
        "UPDATE_PORTAL": {
          "SUCCESS_MESSAGE": "Portal updated successfully",
          "ERROR_MESSAGE": "Unable to update portal"
        }
      }
    },
    "PDF_UPLOAD": {
      "TITLE": "Upload PDF Document",
      "DESCRIPTION": "Upload a PDF document to automatically generate FAQs using AI",
      "DRAG_DROP_TEXT": "Drag and drop your PDF file here, or click to select",
      "SELECT_FILE": "Select PDF File",
      "ADDITIONAL_CONTEXT_LABEL": "Additional Context (Optional)",
      "ADDITIONAL_CONTEXT_PLACEHOLDER": "Provide any additional context or instructions for FAQ generation...",
      "UPLOADING": "กำลังอัพโหลด",
      "UPLOAD": "Upload & Process",
      "CANCEL": "ยกเลิก",
      "ERROR_INVALID_TYPE": "Please select a valid PDF file",
      "ERROR_FILE_TOO_LARGE": "File size must be less than 512MB",
      "ERROR_UPLOAD_FAILED": "Failed to upload PDF. Please try again."
    },
    "PDF_DOCUMENTS": {
      "TITLE": "PDF Documents",
      "DESCRIPTION": "Manage uploaded PDF documents and generate FAQs from them",
      "UPLOAD_PDF": "Upload PDF",
      "UPLOAD_FIRST_PDF": "Upload your first PDF",
      "UPLOADED_BY": "Uploaded by",
      "GENERATE_FAQS": "Generate FAQs",
      "GENERATING": "Generating...",
      "CONFIRM_DELETE": "Are you sure you want to delete {filename}?",
      "EMPTY_STATE": {
        "TITLE": "No PDF documents yet",
        "DESCRIPTION": "Upload PDF documents to automatically generate FAQs using AI"
      },
      "STATUS": {
        "UPLOADED": "Ready",
        "PROCESSING": "Processing",
        "PROCESSED": "เสร็จสิ้น",
        "FAILED": "Failed"
      }
    },
    "CONTENT_GENERATION": {
      "TITLE": "Content Generation",
      "DESCRIPTION": "Upload PDF documents to automatically generate FAQ content using AI",
      "UPLOAD_TITLE": "Upload PDF Document",
      "DRAG_DROP": "Drag and drop your PDF file here, or click to select",
      "SELECT_FILE": "Select PDF File",
      "UPLOADING": "Processing document...",
      "UPLOAD_SUCCESS": "Document processed successfully!",
      "UPLOAD_ERROR": "Failed to upload document. Please try again.",
      "INVALID_FILE_TYPE": "Please select a valid PDF file",
      "FILE_TOO_LARGE": "File size must be less than 512MB",
      "GENERATED_CONTENT": "Generated FAQ Content",
      "PUBLISH_SELECTED": "Publish Selected",
      "PUBLISHING": "Publishing...",
      "FROM_DOCUMENT": "From document",
      "NO_CONTENT": "No generated content available. Upload a PDF document to get started.",
      "LOADING": "Loading generated content..."
    }
  }
}
